import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
import { Props } from '../../../types'
import './Settings.css'
import ContentHeader from '../../../../components/layout/ContentHeader'
import HeaderTitle from '../../../../components/layout/HeaderTitle'
import Content from '../../../../components/layout/Content'
import HeaderActions from '../../../../components/layout/HeaderActions'
import SuspenseFallback from '../../../../components/layout/SuspenseFallback'
import { useTranslation } from 'react-i18next'

function SettingsRoute(props: Props) {
  const {
    component: Component,
    title,
    accountId,
    onHamburgerClick,
    ...rest
  } = props

  const { t } = useTranslation(['tooltips'])

  return (
    <Route {...rest} render={matchProps => (
      <>
        <ContentHeader>
          <HeaderTitle>
            <div id="settings-hamburger" onClick={onHamburgerClick}>
              <i className="fas fa-bars"></i>
            </div>
            {title}
          </HeaderTitle>
          <HeaderActions>
            <a title={t('tooltips:open_account_mainframe')} href={`${process.env.REACT_APP_WEPAPP_URL}/accounts/${accountId}`} target="_blank" rel="noopener noreferrer">
              <i className="far fa-window-maximize settings-nav-icon"></i>
            </a>
          </HeaderActions>
        </ContentHeader>
        <Content>
          <div id="settings-page-container">
            <Suspense fallback={<SuspenseFallback />}>
            <Component {...matchProps} accountId={accountId} {...rest} />
            </Suspense>
          </div>
        </Content>
      </>
    )} />
  )
}

export default SettingsRoute
